import { Shield, Clock, Award, Leaf, Users, CheckCircle, Bug, Home as HomeIcon, Warehouse, Zap } from 'lucide-react';
import React from 'react';

export const services = [
  {
    id: 1,
    name: 'Anti Termite Treatment',
    category: 'termite',
    description: 'Complete termite elimination with advanced barrier treatment and long-lasting protection.',
    icon: <Bug className="text-green-600" size={32} />,
    price: 'Starting ₹2,499',
    features: ['Pre & Post Construction', '5 Year Warranty', 'Eco-Friendly Chemicals']
  },
  {
    id: 2,
    name: 'Pre-Construction Anti-Termite Treatment',
    category: 'termite',
    description: 'Protect your property foundation before construction with chemical barrier treatment.',
    icon: <Warehouse className="text-green-600" size={32} />,
    price: 'Starting ₹1,999',
    features: ['Foundation Treatment', 'Soil Treatment', '10 Year Protection']
  },
  {
    id: 3,
    name: 'Post-Construction Anti-Termite Treatment',
    category: 'termite',
    description: 'Advanced termite treatment for existing structures with drilling and chemical injection.',
    icon: <HomeIcon className="text-green-600" size={32} />,
    price: 'Starting ₹2,999',
    features: ['Wall Drilling', 'Chemical Injection', '5 Year Warranty']
  },
  {
    id: 4,
    name: 'Reticulation System Installation',
    category: 'termite',
    description: 'Modern termite protection system installed during construction for lifetime protection.',
    icon: <Zap className="text-green-600" size={32} />,
    price: 'Starting ₹4,999',
    features: ['Lifetime System', 'Easy Refill', 'Modern Technology']
  },
  {
    id: 5,
    name: 'Cockroach Control Treatment',
    category: 'general',
    description: 'Complete cockroach elimination using gel baiting and safe spray treatment.',
    icon: <Bug className="text-green-600" size={32} />,
    price: 'Starting ₹799',
    features: ['Gel Treatment', 'Spray Application', '90 Day Warranty']
  },
  {
    id: 6,
    name: 'Rodent Control Treatment',
    category: 'general',
    description: 'Humane rodent control with trapping, baiting, and entry point sealing.',
    icon: <Bug className="text-green-600" size={32} />,
    price: 'Starting ₹999',
    features: ['Trap Installation', 'Entry Sealing', '6 Month Protection']
  },
  {
    id: 7,
    name: 'Ant Control Treatment',
    category: 'general',
    description: 'Targeted ant colony elimination with specialized chemical treatment.',
    icon: <Bug className="text-green-600" size={32} />,
    price: 'Starting ₹699',
    features: ['Colony Treatment', 'Barrier Protection', '3 Month Warranty']
  },
  {
    id: 8,
    name: 'Mosquito Control Fogging',
    category: 'general',
    description: 'Outdoor and indoor mosquito control using advanced fogging technology.',
    icon: <Bug className="text-green-600" size={32} />,
    price: 'Starting ₹899',
    features: ['Indoor/Outdoor', 'Safe Chemicals', 'Immediate Results']
  },
  {
    id: 9,
    name: 'Wood Borer Control Treatment',
    category: 'specialized',
    description: 'Specialized treatment to eliminate wood-boring insects from furniture and structures.',
    icon: <Bug className="text-green-600" size={32} />,
    price: 'Starting ₹1,299',
    features: ['Furniture Treatment', 'Structure Protection', '1 Year Warranty']
  },
  {
    id: 10,
    name: 'Honeybee Removal Treatment',
    category: 'specialized',
    description: 'Safe and humane honeybee hive removal by certified experts.',
    icon: <Bug className="text-green-600" size={32} />,
    price: 'Starting ₹1,499',
    features: ['Safe Removal', 'Certified Experts', 'No Harm to Bees']
  }
];

export const serviceLocations = [
  'Dehradun', 'Doiwala', 'Premnagar', 'Rajpur', 'Raiwala',
  'Clement Town', 'Selaqui', 'Roorkee', 'Rishikesh',
  'Almora', 'Bageshwar', 'Chamoli', 'Champawat',
  'Haridwar', 'Nainital', 'Pauri Garhwal',
  'Pithoragarh', 'Rudraprayag', 'Udham Singh Nagar',
  'Tehri Garhwal', 'Uttarkashi'
];

export const whyChooseUs = [
  {
    icon: <Zap className="text-green-600" size={40} />,
    title: 'Fast Service',
    description: 'Same-day service available. Quick response to emergency pest problems.'
  },
  {
    icon: <Shield className="text-green-600" size={40} />,
    title: 'Certified Experts',
    description: 'Government certified technicians with 15+ years of experience.'
  },
  {
    icon: <Leaf className="text-green-600" size={40} />,
    title: 'Safe Chemicals',
    description: '100% eco-friendly and government-approved chemicals safe for family and pets.'
  },
  {
    icon: <Award className="text-green-600" size={40} />,
    title: 'Warranty',
    description: 'Up to 10-year warranty on termite treatments. Free re-treatment if pests return.'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Rajesh Kumar',
    location: 'Dehradun',
    rating: 5,
    text: 'Excellent service! The team was professional and the termite treatment was very effective. Highly recommended!',
    image: 'https://images.unsplash.com/photo-1632661702178-c7d75a2d86e6?auto=format&fit=crop&w=160&h=160&q=85'
  },
  {
    id: 2,
    name: 'Priya Sharma',
    location: 'Rishikesh',
    rating: 5,
    text: 'Very satisfied with the cockroach control service. The team was punctual and used safe chemicals.',
    image: 'https://images.unsplash.com/photo-1567122087721-47b09b61e1d1?auto=format&fit=crop&w=160&h=160&q=85'
  },
  {
    id: 3,
    name: 'Amit Verma',
    location: 'Roorkee',
    rating: 5,
    text: 'Best pest control service in Uttarakhand! Professional team and great results. Worth every penny.',
    image: 'https://images.unsplash.com/photo-1790575188672-ee8d9d4e1c18?auto=format&fit=crop&w=160&h=160&q=85'
  },
  {
    id: 4,
    name: 'Sunita Rawat',
    location: 'Haridwar',
    rating: 5,
    text: 'Amazing service! They removed a honeybee hive safely without harming the bees. Very professional!',
    image: 'https://images.unsplash.com/photo-1766744044648-17acad64453e?auto=format&fit=crop&w=160&h=160&q=85'
  }
];

export const blogCategories = [
  { name: 'Termite', slug: 'termite', count: 12 },
  { name: 'Termite Reticulation', slug: 'termite-reticulation', count: 8 },
  { name: 'Cockroach', slug: 'cockroach', count: 10 },
  { name: 'Rodent', slug: 'rodent', count: 7 },
  { name: 'Ant', slug: 'ant', count: 6 }
];

export const galleryItems = [
  {
    id: 1,
    type: 'image',
    category: 'Anti Termite Work',
    url: 'https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=800&q=80',
    title: 'Anti Termite Treatment'
  },
  {
    id: 2,
    type: 'image',
    category: 'Pre-Construction Work',
    url: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80',
    title: 'Pre-Construction Treatment'
  },
  {
    id: 3,
    type: 'image',
    category: 'Post-Construction Work',
    url: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80',
    title: 'Post-Construction Treatment'
  },
  {
    id: 4,
    type: 'image',
    category: 'Cockroach Work',
    url: 'https://images.unsplash.com/photo-1583256225800-5c1d5c2af9d0?w=800&q=80',
    title: 'Cockroach Control'
  },
  {
    id: 5,
    type: 'image',
    category: 'Rodent Work',
    url: 'https://images.unsplash.com/photo-1585159812596-fac104f2f069?w=800&q=80',
    title: 'Rodent Control'
  },
  {
    id: 6,
    type: 'image',
    category: 'Mosquito Work',
    url: 'https://images.unsplash.com/photo-1599843347624-f956f92d0b1c?w=800&q=80',
    title: 'Mosquito Control'
  }
];